<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <taxablerebategroup-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TaxableRebateGroupForm from "../../../components/payroll/taxablerebategroupsetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

import moment from "moment";

import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "taxablerebategroup-form": TaxableRebateGroupForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setuptaxablerebategroup.edittaxablerebategroup'),
      pageTitleValue: "",
      formData: [],
      errMsg: "",
      isErr: false,
      editMode: true,
      loading: true,
      isConfirm: false,
      taxableRebateGroupHolder: [],
    };
  },

  methods: {
    deleteHandler($event) {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      //add div and change v-on delete
      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch('delete', {url:
              "/taxablerebategroup/" +
              this.id +
              "/" +
              this.formData.userid,
            payload: { data: this.formData }})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "taxablerebategroupsetuplist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "taxablerebategroupsetupnew" });
    },

    cancelHandler() {
      this.$router.push({ name: "taxablerebategroupsetuplist" });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    //update record
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      //set correct date format using moment

      var payload = this.formData;

      this.$store.dispatch('put', {url: "/taxablerebategroup/" + vm.id,
          payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "taxablerebategroupsetuplist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadTaxableRebateGroupDetails() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/taxablerebategroup/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.formData.startdate = moment(vm.formData.startdate).format(
            "YYYY-MM-DD"
          );
          vm.formData.enddate = moment(vm.formData.enddate).format(
            "YYYY-MM-DD"
          );

          vm.formData.lockstaff = res.data.rec[0].lockstaff;
          vm.formData.userid = this.$store.getters.userId;

          vm.loading = !vm.loading;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadTaxableRebateGroupDetails();
  },
};
</script>
